import { FC, useMemo } from 'react';
import {
  Button,
  ButtonContentWithLoader, ButtonVariant,
  SvgIcon,
  useAdvertFavoriteVisibleControl,
} from '@edikk-edikk/ui';
import { Heart } from '@edikk-edikk/icon/Heart';
import { useFavoriteToggleContext, useHandlerClick } from '#baseMenu/components/controls/favorite-toggle/hooks';

const FavoriteToggleButton: FC = () => {
  const { isOpen } = useAdvertFavoriteVisibleControl();
  const { isLoadInProcess } = useFavoriteToggleContext();
  const handlerClick = useHandlerClick();
  const ariaLabel = useMemo(() => (isOpen ? 'Close favorite' : 'Open favorite'), [isOpen]);

  return (
    <Button
      variant={isOpen ? ButtonVariant.white65 : ButtonVariant.black65}
      circle
      onClick={handlerClick}
      aria-label={ariaLabel}
    >
      <ButtonContentWithLoader
        isLoading={isLoadInProcess}
        content={<SvgIcon Component={Heart} width={20} height={20} isWithoutFill isNeedWrap={false} />}
      />
    </Button>
  );
};

export { FavoriteToggleButton };
